import { collectionGroup, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../../firebase";

export const normalizeSaleInsurance = (value) => {
  const insurance = typeof value === "string" ? value.trim() : "";
  return ["", "all", "กรุณาเลือก", "กรุiาเลือก", "please-select"].includes(
    insurance.toLowerCase(),
  ) ? "" : insurance;
};

const bookingDate = (booking) => {
  const value = (booking.extendedProps || {}).latestSleepStudyDate;
  if (value && typeof value.toMillis === "function") return value.toMillis();
  return value ? Date.parse(value) || 0 : 0;
};

// Enrich only the exported copy; do not update saved sale or patient records.
export const enrichCPAPSaleExport = async (order) => {
  const result = { ...order, healthInsurance: normalizeSaleInsurance(order.healthInsurance) };
  const hn = String(order.hn == null ? "" : order.hn).trim();
  if (!hn) {
    if (!result.sleepStudyOrder) result.sleepStudyOrder = "";
    return result;
  }

  // Always refresh study metadata from this patient's latest booking, even
  // when the sale already contains an older study order or AHI.
  const snapshot = await getDocs(query(
    collectionGroup(db, "bookings"),
    where("extendedProps.hn", "==", hn),
  ));
  const bookings = snapshot.docs.map((booking) => booking.data());
  bookings.sort((a, b) => bookingDate(b) - bookingDate(a));
  const ext = (bookings[0] && bookings[0].extendedProps) || {};
  result.sleepStudyOrder = ext.order || "";
  result.ahi = ext.ahi == null ? "" : ext.ahi;

  if (!result.healthInsurance) {
    // Include older bookings and records without a study date when the newest
    // booking has only a placeholder. Sorting here keeps undated records eligible.
    result.healthInsurance = bookings
      .map((booking) => normalizeSaleInsurance((booking.extendedProps || {}).healthInsurance))
      .find(Boolean) || "";

    if (!result.healthInsurance) {
      const patient = await getDoc(doc(db, "patients", hn));
      result.healthInsurance = patient.exists()
        ? normalizeSaleInsurance(patient.data().healthInsurance)
        : "";
    }
  }

  return result;
};
